(function () {
  'use strict';

  // Collection filters: the series dropdown picks the collection, theme and orientation
  // add product tags to its URL (/collections/all/theme-warm+orientation-portrait).
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('[data-collection-filters]');
    if (!bar) return;
    var series = bar.querySelector('[data-filter-series]');
    var tagSelects = Array.prototype.slice.call(bar.querySelectorAll('[data-filter-tags]'));
    var selects = (series ? [series] : []).concat(tagSelects);

    function go() {
      var tags = tagSelects.map(function (select) { return select.value; }).filter(Boolean);
      window.location.href = series.value + (tags.length ? '/' + tags.join('+') : '');
    }

    selects.forEach(function (select) { select.addEventListener('change', go); });

    // Back button: the browser can restore a changed dropdown on the old page, so put each
    // one back to the option the page was rendered with.
    window.addEventListener('pageshow', function () {
      selects.forEach(function (select) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].defaultSelected) { select.selectedIndex = i; return; }
        }
        select.selectedIndex = 0;
      });
    });
  });
})();
